import { Skeleton } from "@mui/material";
import React from "react";

const SkeletonWorkDetail = () => {
    return (
        <div>
            <Skeleton variant="rectangular" width={"100%"} height={80} />
            <Skeleton variant="text" sx={{ fontSize: "1rem", mt: "16px" }} />
            <Skeleton variant="rounded" width={"100%"} height={60} />
            <Skeleton
                variant="rounded"
                sx={{ mt: "16px" }}
                width={"100%"}
                height={300}
            />
            <Skeleton variant="text" sx={{ fontSize: "1rem", mt: "16px" }} />
            <Skeleton variant="rounded" width={"100%"} height={60} />
        </div>
        
    );
};

export default SkeletonWorkDetail;
